// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"electronicArchive_wrapper__2io4g","button":"electronicArchive_button__2ylS7"};